import styled from "styled-components/macro";
import { breakpoint, space } from "shared/styles/constants";

export const StyledRegistrationLayout = styled.div`
  display: grid;
  gap: ${space.xl};

  ${breakpoint("m", "up")} {
    grid-template-columns: 3fr 2fr;
    align-items: start;
    gap: ${space.xl};

    > :first-child {
      order: 1;
    }
  }

  ${breakpoint("l", "up")} {
    gap: ${space.xxxl};
  }
`;
